import PropTypes from 'prop-types';
import React from 'react';

import SearchBarMinimal from 'components/SearchBarMinimal';
import Theme from 'styles/theme';

const SearchBox = ({ currentSearchValue, onSearchChange }) => (
  <div className="SearchBox">
    <div className="SearchBox__container">
      <SearchBarMinimal
        value={currentSearchValue}
        onChange={onSearchChange}
        onClear={() => onSearchChange('')}
      />
    </div>

    <style jsx>
      {`
        .SearchBox {
          display: flex;
          align-items: center;
        }

        .SearchBox__container {
          flex-grow: 1;
        }
      `}
    </style>

    <style jsx global>
      {`
        .SearchBox__cancel.Button {
          padding-left: ${Theme.get('spacing') * 2}px;
          text-decoration: none;
          color: ${Theme.get('colors-black-80')};
        }

        .SearchBox__cancel .Sub {
          color: ${Theme.get('colors-black-80')};
          text-transform: lowercase;
          margin: 0;
        }
      `}
    </style>
  </div>
);

SearchBox.propTypes = {
  currentSearchValue: PropTypes.string,
  onSearchChange: PropTypes.func.isRequired,
};

SearchBox.defaultProps = {
  currentSearchValue: undefined,
};

export { SearchBox };
